export default __webpack_public_path__ + "static/media/perlingo-favicon.76f0c29b.png";